import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";
import { ReportVo } from "src/vo/reportVo";

// 1-1. initial state 객체 생성
const initialState: any = {
  progress: 0,
};

export const bannerAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  // tagTypes: ["Report"],
  reducerPath: "reportAPI",
  endpoints: (builder) => ({
    //  ========================= 완료 보고 상세 화면 =========================
    reportDetail: builder.query({
      query: (as_idx) => ({
        url: `/as/${as_idx}/completion-report`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        providesTags: ["ReportVo"],
      }),
      transformResponse: (response: any) => response.data,
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
    allBanner: builder.query({
      query: () => ({
        url: `/common/banner/all`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // ========================= banner 등록 =========================
    addBanner: builder.mutation({
      query: (data: any) => ({
        url: `/common/banner/all`,
        method: "POST",
        headers: {
        },
        body: data,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
// export const { useAsTestQuery } = asListAPI;

export const { useReportDetailQuery, useAllBannerQuery, useAddBannerMutation } = bannerAPI;
